import { Utils } from "@/plugins/utils"
import router from "@/router"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstCv8: [],
        cv8: {},
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
        sinceEmit: moment().subtract(1, 'month').format("YYYY-MM-DD 00:00"),
        untilEmit: moment().format("YYYY-MM-DD 23:59"),
        sinceDue: "",
        untilDue: "",
        cv8tipotit: "",
        lstCv8confirmed: [],
        statusCv8Chip: [0, 1],
	},
    getters: {
        getSearch(state) {
            return state.search || "";
        }
    },
	mutations: {
        setSearch(state, search) {
			state.search = search
		},
		setLoading(state, loading) {
			state.loading = loading
		},
        setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
        setLstCv8(state, lstCv8) {
            state.lstCv8 = lstCv8
        },
        clearSearch(state) {
            state.lstCv8 = []
            state.search = ""
            state.cv8tipotit = ""
            state.hasNext = false
        },
        setParamsDataTable(state, payload) {
            state.lstCv8 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
	},
	actions: {
        async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
            commit("setLoading", true)

            let urlChipParams = ""

            for (const status of state.statusCv8Chip) {
                urlChipParams += `&statusCv8Chip=${status}`
            }

            if (state.sinceEmit) urlChipParams += `&sinceDate=${state.sinceEmit}`
            if (state.untilEmit) urlChipParams += `&untilDate=${state.untilEmit}`
            if (state.sinceDue) urlChipParams += `&sinceDueDate=${state.sinceDue}`
            if (state.untilDue) urlChipParams += `&untilDueDate=${state.untilDue}`
            if (state.cv8tipotit) urlChipParams += `&cv8tipotit=${encodeURIComponent(state.cv8tipotit)}`

            let payload = await this._vm.$axios.get(
                `/Financial/BankTransactionItems/SearchMultipleTitles?` +
                `search=${getters.getSearch || ""}` +
                `&limit=${limit}` +
                `&page=${page}` +
                urlChipParams
            )
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                commit("setParamsDataTable", payload)
                return true
            })
            .catch((error) => {
                commit("setLstCv8", [])
                commit("setSearch", "")
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            commit("setLoading", false)
            return payload
        },
	},
}
